import React, { Component } from 'react';
import { connect } from 'react-redux';
import GetError from '../Response/GetError';
import GetResponse from '../Response/GetResponse';

import API from'../../../services/Api'

const toJSON = ( form )  => {
    var object = {};
    form.forEach(function(value, key){
        object[key] = value;
    });
    return object;
}

class ConnectedAddUser extends Component {
    constructor(props){
        super(props)

        this.state = {
            email: null,
            password: null,
            name: null,
            job: null,
            country: null,
            postalcode: null,
            error: null,
            response: null
        }

        // Handle Change
        this.handleChangeEmail = this.handleChangeEmail.bind(this);
        this.handleChangePassword = this.handleChangePassword.bind(this);
        this.handleChangeName = this.handleChangeName.bind(this);
        this.handleChangeJob = this.handleChangeJob.bind(this);
        this.handleChangePostalcode = this.handleChangePostalcode.bind(this);

        // Handle Submit
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount(){
        // var xdr = new XMLHttpRequest(); 
        // xdr.responseType = 'json';
        // xdr.open("GET", this.props.app.dns+'/'+this.props.app.version+'/countries/info/{"lang":"fr_FR"}', true);
        // xdr.setRequestHeader("Authorization", "Bearer "+this.props.app.token);

        // xdr.send();
        // xdr.onload = () => {
        //     this.setState({
        //         countries: xdr.response
        //     })
        // }
    }

    handleSubmit(event){
        event.preventDefault();
        
        if(this.state.email === null || this.state.password === null || this.state.name === null
            // || this.state.gender === null || this.state.country === null || this.state.postalcode === null
            ){
                
                this.setState({
                    error: "Erreur"
                })
            }

            API.addClient({
                ...this.state,
                username : this.state.email,
                surname: this.state.name,
                job: Number(this.state.job) || 0,
                postalcode: this.state.postalcode,
                created: new Date(),
            }).then(res => {
                var response = res.data
                this.setState({response})
            })
    }

    handleChangeEmail(event) {
        this.setState({email: event.target.value});
    }
    handleChangePassword(event) {
        this.setState({password: event.target.value});
    }
    handleChangeName(event) {
        this.setState({name: event.target.value});
    }
    handleChangeJob(event) {
        this.setState({job: event.target.value});
    }
    handleChangePostalcode(event) {
        this.setState({postalcode: event.target.value});
    }

    render() {
        let condition = (this.state.error !== null);
        let conditionResponse = (this.state.response !== null);
        
        return (
            <div className="ui container">
                <div className="ui center aligned container">
                <br/>
                <h1 className="ui header">User Area</h1>
                <h2 className="ui header">Inscription</h2>
                <br/>
                </div>

                {condition ? (
                    <GetError data={this.state} />
                ): (
                    <div></div>
                )}

                <div className="ui container stackable three column grid">
                    <div className="ui column">
                    </div>
                    <div className="ui column">
                        <form className="ui form" onSubmit={this.handleSubmit}>
                            <div className="field">
                                <label>NOM</label>
                                <input onChange={this.handleChangeName} />
                            </div>
                            <div className="field">
                                <label>E-MAIL ADRESS</label>
                                <input type="email" onChange={this.handleChangeEmail} />
                            </div>
                            <div className="field">
                                <label>MOT DE PASSE</label>
                                <input type="password" onChange={this.handleChangePassword} />
                            </div>
                            <div className="field">
                                <label>CATEGORIE</label>
                                <select onChange={this.handleChangeJob}>
                                    <option selected="selected"></option>
                                    <option value="0">Administrateur</option>
                                    <option value="3">Entreprises</option>
                                    <option value="2">Prescripteurs</option>
                                    <option value="1">Commerciaux</option>
                                    <option value="4">Particulier</option>
                                </select>
                            </div>
                            <div className="field">
                                <label>CODE POSTAL</label>
                                <input onChange={this.handleChangePostalcode} />
                            </div>

                            <button type="submit" className="ui button" role="button">Submit</button>
                        </form>
                    </div>
                </div>
                
                {conditionResponse ? (
                    <GetResponse data={this.state} />
                ): (
                    <div></div>
                )}
                
            </div>
        );
    }
}

const AddUser = (ConnectedAddUser);

export default AddUser;



// WEBPACK FOOTER //
// ./src/components/Protected/User/AddUser.jsx